import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  Inject,
  HostListener,
  PLATFORM_ID,
  Renderer2,
  Injector,
  Input} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
// import { StorageService } from '@citi-gcg-173875/citi-utils';
import {
  SvcServices,
  BackendService,
  ContentService,
  ProfilingService,
  DmarService,
  windowService,
  HoneyPotService,
  E2eService,
  PopupModalService,
  CrsFidoService } from '../../services';
/**commented below code to stop sitecatlsyt code to execute, for this we added adobe launch */
 import { SiteCatalystService } from 'app/services';
 import { SiteCatalystPageData } from 'app/models';
/** Addded below code to execute adobe launch */
//import { AdobePageData } from 'app/models/adobe.model';
//import { AdobeService } from 'app/services/adobe.service';
import { catchError } from 'rxjs/operators';
import {
  coreValidator,
  booleanValidator,
  valid_at_least_5,
  valid_at_least_6,
  valid_not_more_than_50,
  valid_not_more_than_32,
  valid_not_more_than_64,
  valid_acceptable,
  valid_required } from '../../services';

import { Observable, from } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { AppConfigService  } from '@citi-gcg-173875/citi-utils';
// import { AppConfigService, StorageService  } from '@citi-gcg-169073/ccp-uiux-angular/services';
import { HttpClient } from '@angular/common/http';
import { ChatbotService } from "../../shared/common-component/service/chatbot.service";
import * as moment from 'moment-timezone';
import { ContentObserver } from '@angular/cdk/observers';
import { BrowserStorageService } from '../../services/browser.storage.service';

@Component({
  selector: 'sign-on-form',
  templateUrl: './sign-on-form.component.html'
})
export class SignOnFormComponent implements OnInit {

  // @ViewChild('primaryBanner') primaryBanner: ElementRef;
  // @ViewChild('secondaryBanner') secondaryBanner: ElementRef;
  // @ViewChild('signonFormContainer') signonFormContainer: ElementRef;
  @Input() XXXExtra: any;
  @Input() pageData: any;
  chatbotService: ChatbotService;
  scPageData: SiteCatalystPageData;
  window: any;
  public isCPAY: boolean=false;
  isSingleFuipFlow: boolean=false;  //single fuip flow
  fuipUrl: string;
  guestUrl: string;
  showGuestPaySection: boolean=false;
  isSignonFlexSeoDisable: boolean=false;
  config: any;
  api: any;
  endpointMap: any;
  channel: any;
  endpoints: Map<string, string>;

  constructor(
    private fb: FormBuilder,
    private _profiligServices: ProfilingService,
    private _svcService: SvcServices,
    private _backend: BackendService,
    private _contentService: ContentService,
    private scService: SiteCatalystService,
    private route: ActivatedRoute,
    private _http: HttpClient,
    private _dmarService: DmarService,
    public _appConfigService: AppConfigService,
    public _hpTokenService: HoneyPotService,
    //private _storageService: StorageService,
    private crsFidoService: CrsFidoService,
    private _renderer: Renderer2,
    private _el: ElementRef,
    private e2eService: E2eService,
    public _windowService: windowService,
    private popupModalService: PopupModalService,
    private _injector: Injector,
    @Inject(PLATFORM_ID) private platformId: string) {
    if(!isPlatformBrowser(this.platformId)) {
      global['localStorage'] = new BrowserStorageService();
      global['sessionStorage'] = new BrowserStorageService();
    }
    this.window = _windowService.nativeWindow;
    this.chatbotService = _injector.get<ChatbotService>(ChatbotService);
    this.setConfig();
  }

  setConfig() {
    this.config = this._appConfigService.getConfig("api");
    this.api = this.config;
    this.endpointMap =
      Object
        .keys(this.config?.endpoints)
        .reduce((map, endpoint, i) => {
          map[i] = [endpoint, this.config?.endpoints[endpoint]];
          return map;
        }, []);
    this.channel = this.config?.channel;
    this.endpoints = new Map(this.endpointMap);
  }

  // config = this._appConfigService.getConfig("api");
  // api = this.config;
  // endpointMap =
  //   Object
  //     .keys(this.api.endpoints)
  //     .reduce((map, endpoint, i) => {
  //       map[i] = [endpoint, this.api.endpoints[endpoint]];
  //       return map;
  //     }, []);
  // channel = this.api.channel;
  capsOn;
  moduleLoaded = false;
  formSubmitted = false;
  urlParameters: any;
  hashValue = '';
  error: any;
  notifications: any;
  adBlockerEnabled: boolean = false;
  retrieveUrl: string;
  resetUrl: string;
  registrationUrl: string;
  matchedId: any;
  submitButtonDisabled: boolean = false;
  isPrimaryContentDiffFromFlexSeo: boolean;
  urgentNotification: any[] = [];
  loginForm: FormGroup;
  biometricLoginForm: FormGroup;
  moduleContent: any;
  savedUserID: any;
  tmx_sessionId: string;
  globalData: any;
  // public endpoints: Map<string, string> = new Map(this.endpointMap);

  isBiometricEligible: Boolean = true;
  BiometricBTN: string = "";
  biometricUserId: string = "";
  biometricSubmitButtonDisabled: boolean = false;
  biometricFormSubmitted = false;
  biometricCyotaId: string = "";
  biometricButtonText: string = "";
  biometricButtonADAText: string = "";
  temp:boolean=false;
  setupPartner:boolean;
  notification_encountered_a_problem : string = "";
  module: string = 'sign_on';
  formId: string = "sign_on";
  //biometricEligibilePartner:string="PLCN_MEIJER,PLCN_WFCC,PLCN_LLBEAN";
  isSingleSignon:boolean;
  isFirstTimeUser: boolean = false;
  siteIdCan: string = "";
  isThdPartner: boolean= false;
  // local model for signon validation
  private localModel = {
    userId: '',
    password: '',
    rememberMe: false,
    canadaCookieConsent: false
  };



  ngOnInit() {
    this.urlParameters = this._contentService.getParams();
    let siteId = this.urlParameters.siteId;
    this.siteIdCan = this.urlParameters.siteId.toUpperCase();
    console.log("this._svcService.getSiteId()" + this._svcService.getSiteId());
    console.log("siteId=>", siteId);
    // fetch biometric elligibility of the user
    //console.log("Checking Eligiblity for Biometric");
    this.setupPartner = this.checkSetupContent();
    this.checkBiometricEligibility();
    this.isThdPartner= this.isThd();
    //console.log("Eligible Status", this.isBiometricEligible);
    // to get legacy sign on page response
    //console.log(this.pageData)
    this.getSignNotifications();
    this.createLoginForm();
    this.BiometricBTN = "Sign On";
  //  this.adBlockerEnabled = this._dmarService.isAdBlockerEnabled();
     if(this._dmarService.isAdBlocking == true){
      this.adBlockerEnabled = true;
    }
    this.retrieveUrl = this.getRedirectUrl('#retrieve');
    this.resetUrl = this.getRedirectUrl('#reset');
    this.registrationUrl = this.getRedirectUrl('#verify', '/RSnextgen/svc/registration/index.action?siteId=');
    this.isPrimaryContentDiffFromFlexSeo = this._dmarService.primaryContentDiffFromFlexSeo();
    this.tmx_sessionId = this._profiligServices.get_new_tmx_sessionid();
    this.getBrandId();
    this.moduleLoaded=true
    this.isCPAY = this.urlParameters.siteId == "PLCN_CPAY" ? true : false;

    //Fuip
    if (this.pageData?.config$$cfg_cw_app_client_settings?.RSauth_redirection_url_for_fuip?.split(",").includes(siteId.toUpperCase())) {
      this.isSingleFuipFlow = true;
    } else{
      this.isSingleFuipFlow = false;
    }

    if (this.pageData?.config$$cfg_cw_app_client_settings?.signon_angular_flexseo_disabled?.includes(siteId.toUpperCase())) {
      this.isSignonFlexSeoDisable = true;
    } else{
      this.isSignonFlexSeoDisable = false;
    }
    console.log("this.isSignonFlexSeoDisable=" + this.isSignonFlexSeoDisable);
    /*Load the SSR SSO page with PageName=singlesignon
      Setting the seesion storage to identify the page is Signon or Single Signon.
    */
    this.isSingleSignon = this.urlParameters.pageName === "singlesignon";
    if(this.isSingleSignon){
      sessionStorage.setItem("isSingleSignon", "true");
      this.window.dataLayer.pageName = "single_sign_on";
      sessionStorage.setItem('currentPage', this.window.dataLayer.pageName);
      this.module = "single_sign_on";
      this.formId = "single_sign_on";
      this.ngaSSOSetup();
    }else{
      sessionStorage.removeItem("isSingleSignon");
    }
    if (this.pageData?.config$$cfg_cw_app_client_settings.guestpay_enabled === true ||
      this.pageData?.config$$cfg_cw_app_client_settings.guestpay_enabled === 'true') {
      this.showGuestPaySection = true;
  } else {
    this.showGuestPaySection = false;
  }
  sessionStorage.removeItem('paymentPopupShowed');
  sessionStorage.removeItem('interstitialtype');
  sessionStorage.removeItem('collections_takeover');
  sessionStorage.removeItem('BBYRewardsOfferPopupShowed');
}

  ngAfterViewInit() {
    if (this.isBiometricEligible) {
      this.biometricLoginForm.controls['userId'].setValidators([
        coreValidator(valid_at_least_5, (this.pageData.copy$$errormsg_userid_5to50_length) ? this.pageData.copy$$errormsg_userid_5to50_length.TEXT : ''),
        coreValidator(valid_not_more_than_50, (this.pageData.copy$$errormsg_userid_5to50_length) ? this.pageData.copy$$errormsg_userid_5to50_length.TEXT : ''),
        coreValidator(valid_required, (this.pageData.copy$$errormsg_enter_userid) ? this.pageData.copy$$errormsg_enter_userid.TEXT : '')
      ]);
    } else {
      this.loginForm.controls['userId'].setValidators([
        coreValidator(valid_at_least_5, (this.pageData.copy$$errormsg_userid_5to50_length) ? this.pageData.copy$$errormsg_userid_5to50_length.TEXT : ''),
        coreValidator(valid_not_more_than_50, (this.pageData.copy$$errormsg_userid_5to50_length) ? this.pageData.copy$$errormsg_userid_5to50_length.TEXT : ''),
        coreValidator(valid_required, (this.pageData.copy$$errormsg_enter_userid) ? this.pageData.copy$$errormsg_enter_userid.TEXT : '')
      ]);
      this.loginForm.controls['password'].setValidators([
        coreValidator(valid_at_least_6, (this.pageData.copy$$error_password_invalid_length_msg) ? this.pageData.copy$$error_password_invalid_length_msg.TEXT : ''),
        coreValidator(valid_not_more_than_64, (this.pageData.copy$$error_password_invalid_length_msg) ? this.pageData.copy$$error_password_invalid_length_msg.TEXT : ''),
        coreValidator(valid_required, (this.pageData.copy$$errormsg_enter_your_password) ? this.pageData.copy$$errormsg_enter_your_password.TEXT : '')
      ]);
      console.log("this.siteIdCan === "+ this.siteIdCan);
      if(this.siteIdCan == "CACN_HOMEDEPOT") {
        this.loginForm.controls['canadaCookieConsent'].setValidators([
          booleanValidator((this.pageData.copy$$errormsg_enter_your_canadaCookieConsent) ? this.pageData.copy$$errormsg_enter_your_canadaCookieConsent.TEXT : '', this.localModel.canadaCookieConsent)
        ]);
      }

    }

    if (isPlatformBrowser(this.platformId)) {
      this.scService.attachFormSCEvents("sign_on");
    }

    if(sessionStorage && (typeof sessionStorage.removeItem == 'function')) {
      sessionStorage.removeItem('sowPopupShowed');
    }

    if (this.savedUserID) {
      var inputItem = this._el.nativeElement.querySelector('*[type^="text"]');
      if (inputItem.id == "userId") {
        this._renderer.addClass(inputItem, 'placeholderShown');
      }
    }
    this._svcService.isSignOnLoaded.emit(true);

    if (this.pageData &&
      this.pageData.config$$cfg_cw_app_client_settings.covid_proactive_prelogin_enabled_partners.includes(this._svcService.getSiteId())) {
      setTimeout(() => {
        //open popup modal when the page load for info warning message on it
        this.popupModalService.openPopupContent.emit({
          popupContentComponent: "popup-site-info",
          popupContentParams: ""
        });
      }, 500);
    }

  }


  ngaSSOSetup() {
    let headerData = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'accept': 'text/json,application/json'
    };
    let ssoPartnerUserId = sessionStorage.getItem("ssoPartnerUserId") ? sessionStorage.getItem("ssoPartnerUserId") : '';
    let ssoPartnerRedirectUrl = sessionStorage.getItem("ssoPartnerRedirectUrl") ? sessionStorage.getItem("ssoPartnerRedirectUrl") : '';
    let ssoState = sessionStorage.getItem("ssoState") ? sessionStorage.getItem("ssoState") : '';
    if (sessionStorage.getItem("isExpiredRefreshToken")) {
      this.isFirstTimeUser = sessionStorage.getItem("isSingleSignon") === "true" ? true : false;
    }
    let url = this.endpoints.get('ngassosetup/action').replace("{SITE_ID}", this.urlParameters.siteId).replace("{PARTNER_USER_ID}", ssoPartnerUserId).replace("{PARTNER_REDIRECT_URL}", ssoPartnerRedirectUrl).replace("{STATE}", ssoState);

      this._http.get(url, { headers: headerData }).subscribe((data) => {
        if (data !== null && data !== undefined) {
          let responseData = JSON.parse(JSON.stringify(data));
          console.log("ngassosetup transId >>" + responseData.transId);
          if (responseData.transId == "nga_sso_success") {
            sessionStorage.setItem("ngaSSOTransId", responseData.transId);
            sessionStorage.setItem("ngaSSOMessage", responseData.message ? responseData.message : '');
          } else if(responseData.transId == "nga_sso_failure"){
            sessionStorage.setItem("ngaSSOTransId", responseData.transId);
            sessionStorage.setItem("ngaSSOMessage", responseData.message ? responseData.message : '');
            this.notification_encountered_a_problem = this.pageData.copy$$notification_encountered_a_problem ? this.pageData.copy$$notification_encountered_a_problem.TEXT : "";
          }
        } else {
          this.notification_encountered_a_problem = this.pageData.copy$$notification_encountered_a_problem ? this.pageData.copy$$notification_encountered_a_problem.TEXT : "";
          sessionStorage.setItem("ngaSSOTransId", "nga_sso_failure");
          sessionStorage.setItem("ngaSSOMessage", this.notification_encountered_a_problem);
        }
        //session value removed
        // sessionStorage.removeItem('ssoPartnerUserId');
        // sessionStorage.removeItem('ssoPartnerRedirectUrl');
        // sessionStorage.removeItem('ssoState');
      },
        (error: any): any => {
         if(error.status != 200){
            this.notification_encountered_a_problem = this.pageData.copy$$notification_encountered_a_problem ? this.pageData.copy$$notification_encountered_a_problem.TEXT : "";
            sessionStorage.setItem("ngaSSOTransId", "nga_sso_failure");
            sessionStorage.setItem("ngaSSOMessage", this.notification_encountered_a_problem);
            //session value removed
            sessionStorage.removeItem('ssoPartnerUserId');
            sessionStorage.removeItem('ssoPartnerRedirectUrl');
            sessionStorage.removeItem('ssoState');
         }
      });
  }

  checkSetupContent() {
    const siteId = this.getSiteIdfromUrl();
    console.log(siteId,"site id");
    if(siteId == 'PLCN_DILLARDS')
      return false;
    else
      return true;
  }

  isThd(){
    const siteId = this.getSiteIdfromUrl();
    if(siteId == 'PLCN_HOMEDEPOT')
      return true;
    else
      return false;
  }
  

  checkBiometricEligibility() {
    console.log("localStorage==", localStorage);
    const siteId = this.getSiteIdfromUrl();
    const userId = localStorage.getItem(siteId?.toUpperCase() + "_userId");
    this.biometricUserId = userId !== null ? userId : "";
    const cyotaId = localStorage.getItem(siteId?.toUpperCase() + "_fidoUserId");
    const biometricEligible = this.biometricEligiblePartner(siteId);
    //For device testing . Will be removed
    try {

        if (!!userId && !!cyotaId && biometricEligible === true) {
          this.biometricCyotaId = cyotaId;
          const fidoRegistration = localStorage.getItem(siteId?.toUpperCase() + "_userFIDORegistered");
          if (fidoRegistration === "true") {
            //console.log("Eligible for Biometric");
            this.isBiometricEligible = true;
            this.window.dataLayer.pageName = "biometric_sign_on";
            this.biometricButtonText = this.pageData.copy$$biometric_btn_sign_on ? this.pageData.copy$$biometric_btn_sign_on.TEXT : "";
            this.biometricButtonADAText = this.pageData.copy$$biometric_btn_sign_on ? this.pageData.copy$$biometric_btn_sign_on.WCAG_TEXT : "";
          } else {
            this.isBiometricEligible = false;
          }

        } else {
          this.isBiometricEligible = false;
        }

    } catch (err) {
      //console.error(err);
      this.isBiometricEligible = false;
    }
  }

  biometricEligiblePartner(siteId: string) {
    let result = false;
    try {
      if (this.pageData && this.pageData.config$$cfg_cw_app_client_settings.biometric_login_partners.includes(siteId)) {
      //if (this.biometricEligibilePartner.includes(siteId)) {
        result = true;
      } else {
        result = false;
      }
    } catch (err) {
      //console.error("Exception occured while fetching biometricEligiblePartner " + err);
      result = false;
    }
    return result;
  }

  createLoginForm() {
    this.savedUserID = localStorage.getItem(this._svcService.getSiteId()) ? localStorage.getItem(this._svcService.getSiteId()) : null;
    console.log(this.savedUserID)
    if (this.isBiometricEligible) {
      this.biometricLoginForm = new FormGroup({
        'userId': new FormControl(this.biometricUserId, {})
      })

    } else {
      console.log("this.siteIdCan2 === "+ this.siteIdCan);
      if(this.siteIdCan == "CACN_HOMEDEPOT") {
        this.loginForm = new FormGroup({
          'userId': new FormControl((this.savedUserID !== null) ? this.savedUserID : this.localModel.userId, {
            validators: [
              coreValidator(valid_required, (this.pageData.copy$$errormsg_enter_userid) ? this.pageData.copy$$errormsg_enter_userid.TEXT : '')
            ],
            updateOn: "blur"
          }),
          'rememberMe': new FormControl((this.savedUserID) ? true : this.localModel.rememberMe),
          'password': new FormControl(this.localModel.password, [
            coreValidator(valid_required, (this.pageData.copy$$errormsg_enter_your_password) ? this.pageData.copy$$errormsg_enter_your_password.TEXT : '')
          ]),
          'canadaCookieConsent': new FormControl(this.localModel.canadaCookieConsent, [
            booleanValidator((this.pageData.copy$$errormsg_enter_your_canadaCookieConsent) ? this.pageData.copy$$errormsg_enter_your_canadaCookieConsent.TEXT : '', this.localModel.canadaCookieConsent)
          ])
        });
      } else {
        this.loginForm = new FormGroup({
          'userId': new FormControl((this.savedUserID !== null) ? this.savedUserID : this.localModel.userId, {
            validators: [
              coreValidator(valid_required, (this.pageData.copy$$errormsg_enter_userid) ? this.pageData.copy$$errormsg_enter_userid.TEXT : '')
            ],
            updateOn: "blur"
          }),
          'rememberMe': new FormControl((this.savedUserID) ? true : this.localModel.rememberMe),
          'password': new FormControl(this.localModel.password, [
            coreValidator(valid_required, (this.pageData.copy$$errormsg_enter_your_password) ? this.pageData.copy$$errormsg_enter_your_password.TEXT : '')
          ])
        });
      }
    }

    if (this.savedUserID) {
      this.clearMaskedInput();
    }
  }



  public get userId() {
    return this.loginForm.get('userId');
  }
  public get password() {
    return this.loginForm.get('password');
  }
  public get rememberMe() {
    return this.loginForm.get('rememberMe');
  }
  public get canadaCookieConsent() {
    return this.loginForm.get('canadaCookieConsent');
  }

  onSubmit() {
    this.formSubmitted = true;
    if (this.loginForm.valid) {        
      this.submitButtonDisabled = true;
      this.error = "";
      //this.loginEvent.emit({ type: 'requested', value: this.loginForm.value });
      console.log("**** Login From Validated Successfully **** Call Sign On Action Service From Here");
      let processName = '';
      let blackbox = encodeURIComponent(this._profiligServices.getCyotaData());
      let userCookie = 'testCoockie';
      let devicePrint = encodeURIComponent(this._profiligServices.getInetData());
      let DESC = this.route.snapshot.queryParams.desc;
      if (DESC == null || DESC == undefined) {
        DESC = '';
      }
      let cmp = this.route.snapshot.queryParams.cmp;
      if (cmp == null || cmp == undefined) {
        cmp = '';
      }
      let siteId = this.route.snapshot.queryParams.siteId;
      if (siteId == null || siteId == "" || siteId == undefined) {
        siteId = this.urlParameters.siteId;
      }
      if (siteId == null || siteId == "" || siteId == undefined) {
        siteId = this.getSiteIdfromUrl();
      }      
      console.log("this.siteId onSubmit: ",siteId);
      if (siteId?.toUpperCase() == "PLCN_BESTBUY"){
          sessionStorage.setItem('bby_previous_page', "sign_on");
      }
      let langId = this.route.snapshot.queryParams.langId;
      let userId = this.loginForm.value["userId"];
      let userIdEncoded = encodeURIComponent(userId);
      let passwordEncoded = encodeURIComponent(this.loginForm.value["password"]);
      let isRememberEnabled = this.loginForm.value["rememberMe"];
            let snapshot_events = 'test_snapShot';
      let windowId = this._contentService.getWindowIdFromSessionStorage();
      let userFlow = this.isSingleSignon?'ngaSingleSignOn':'NGAsignon';
      let signOnkeyAuthCode = sessionStorage.getItem("signOnkeyAuthCode");
      let ngaSsoAuthCode = sessionStorage.getItem("ngaSsoAuthCode");

      console.log("this.siteIdCan3 === "+ this.siteIdCan);
      let signOnRequest = "";
      if(this.siteIdCan == "CACN_HOMEDEPOT") {
        let canadaCookieConsent = this.loginForm.value["canadaCookieConsent"];
        signOnRequest = 'processName=' + processName + '&'
        + 'blackbox=' + blackbox + '&'
        + 'userCookie=' + userCookie + '&'
        + 'devicePrint=' + devicePrint + '&'
        + 'DESC=' + DESC + '&'
        + 'cmp=' + cmp + '&'
        + 'siteId=' + siteId + '&'
        + 'langId=' + langId + '&'
        + 'userFlow=' + userFlow + '&'
        + 'userId=' + userIdEncoded + '&'
        + 'password=' + passwordEncoded + '&'
        + 'canadaCookieConsent=' + canadaCookieConsent + '&'
        + 'XXX_Extra=' + this.XXXExtra + '&'
        + 'snapshot_events=test&'
        + 'tmx_sessionId=' + this.eny(this.tmx_sessionId) + '&'
        + 'keyBizToken='+ this._backend.bizToken + '&'
        + 'windowId=' + windowId;
      } else {
        signOnRequest = 'processName=' + processName + '&'
        + 'blackbox=' + blackbox + '&'
        + 'userCookie=' + userCookie + '&'
        + 'devicePrint=' + devicePrint + '&'
        + 'DESC=' + DESC + '&'
        + 'cmp=' + cmp + '&'
        + 'siteId=' + siteId + '&'
        + 'langId=' + langId + '&'
        + 'userFlow=' + userFlow + '&'
        + 'userId=' + userIdEncoded + '&'
        + 'password=' + passwordEncoded + '&'
        + 'XXX_Extra=' + this.XXXExtra + '&'
        + 'snapshot_events=test&'
        + 'tmx_sessionId=' + this.eny(this.tmx_sessionId) + '&'
        + 'keyBizToken='+ this._backend.bizToken + '&'
        + 'windowId=' + windowId;
      }


      if(userFlow == 'ngaSingleSignOn'){
        let ssoPartnerUserId = sessionStorage.getItem("ssoPartnerUserId") ? sessionStorage.getItem("ssoPartnerUserId") : '';
        let ssoPartnerRedirectUrl = sessionStorage.getItem("ssoPartnerRedirectUrl") ? sessionStorage.getItem("ssoPartnerRedirectUrl") : '';
        signOnRequest = signOnRequest + '&partnerUserId=' + ssoPartnerUserId + '&'
                        + 'partnerRedirectUrl=' + ssoPartnerRedirectUrl + '&'
                        +'signOnkeyAuthCode=' + signOnkeyAuthCode + '&'
                        + 'ngaSsoAuthCode=' + ngaSsoAuthCode;
      }
      try {
        let headerData = {
          'Content-Type': 'application/x-www-form-urlencoded',
          'accept': 'text/json,application/json'
        };


        // Addede the below code to check sign on submit
        console.log("URL from sign-on-form-component.ts for invokeSignOn" + this.endpoints.get('ngaSignOn/submission'));
        return this._http.post(this.endpoints.get('ngaSignOn/submission'),
          signOnRequest, { headers: headerData }).subscribe((data) => {
            if (data !== null && data !== undefined) {
              let responseData = JSON.parse(JSON.stringify(data));
              console.log("if subcribe page data >>" + responseData.transId);
              if (responseData.transId == "signonSuccess" || responseData.transId == "firsttime_user") {
                this.chatbotService.chatBotDestroy();
                console.log("Re-directing to legacy");
                this._contentService.createKnownUserKey();

                if (isRememberEnabled) {
                  //this._storageService.set("userId", userId, StorageService.LOCALSTORAGE);
                  localStorage.setItem(siteId?.toUpperCase(), userId);
                } else {
                  if(localStorage.getItem(this._svcService.getSiteId())) {
                    localStorage.removeItem(this._svcService.getSiteId());
                  }
                }
                if (responseData.biometricEnrollmentEligible) {
                  try {
                    const redirectUrl = this.getRedirectUrlForNgaSignon("&pagename=authenticate#ngaSignOn", "");
                    localStorage.setItem("siteId", siteId?.toUpperCase());
                    localStorage.setItem(siteId?.toUpperCase() + "_userId", userId);
                    localStorage.setItem(siteId?.toUpperCase() + "_fidoUserId", responseData.cyotoUserId);
                    localStorage.setItem(siteId?.toUpperCase() + "_redirectUrlNgaSignon", redirectUrl);
                    this.crsFidoService.initialize(responseData);
                  } catch (error) {
                    window.location.href = this.getRedirectUrlForNgaSignon("&pagename=authenticate#ngaSignOn", "");
                  }
                } else {
                  window.location.href = this.getRedirectUrlForNgaSignon("&pagename=authenticate#ngaSignOn", "");
                }

              }
              else if (responseData.transId == "redirectToResetPwd") {
                console.log("Re-directing to legacy redirectToResetPwd");
                window.location.href = this.getRedirectUrl("#reset");
              }
              else if (responseData.transId == "redirectToRetrieveUserID") {
                console.log("Re-directing to legacy redirectToRetrieveUserID");
                window.location.href = this.getRedirectUrl("#retrieve");
              }
              else {
                //Display error message from sign on response
                if (responseData.message !== null && responseData.message !== undefined) {
                  this.error = responseData.message;
                }
                if (responseData.notifications !== null && responseData.notifications !== undefined) {
                  this.notifications = responseData.notifications;
                }

                if(responseData.error_code == 5002){
                  localStorage.removeItem(siteId?.toUpperCase() + "_userId");
                  localStorage.removeItem(siteId?.toUpperCase() + "_fidoUserId");
                  localStorage.removeItem(siteId?.toUpperCase()+'_userFIDORegistered');
                }
                //this._storageService.delete("userId", StorageService.LOCALSTORAGE);
                if(localStorage.getItem(this._svcService.getSiteId())) {
                  localStorage.removeItem(this._svcService.getSiteId());
                }
                this.loginForm.reset();

                this.submitButtonDisabled = false;
                var inputTxt = this._el.nativeElement.querySelector('*[type^="text"]');
                var inputPwd = this._el.nativeElement.querySelector('*[type^="password"]');
                this.clearMaskedInput();
                this._renderer.removeClass(inputTxt, 'placeholderShown');
                this._renderer.removeClass(inputPwd, 'placeholderShown');
                console.log("this.siteIdCan4 === "+ this.siteIdCan);
                if(this.siteIdCan == "CACN_HOMEDEPOT") {
                  var inputChkCookie = this._el.nativeElement.querySelector('*[id^="canadaCookieConsent"]');
                  this._renderer.removeClass(inputChkCookie, 'placeholderShown');
                }
                this._svcService.triggerProcessCompletionForSpinner(true);
                console.log("data.transId >>> " + responseData.transId);
              }
            } else {
              this.clearFormOnError();
            }
          },
            (error: any): any => {
              this.clearFormOnError();
            });

      }
      catch (ex) {
        console.log('Exception in ngaSignOnSubmit' + ex);
      }

    } else {
      for (const controlName in this.loginForm.controls) {
        if (this.loginForm.controls.hasOwnProperty(controlName)) {
          this.loginForm.controls[controlName].markAsTouched();
        }
      }
      this.loginForm.markAsTouched();
    }
  }

  eny(data) {
    let encryptedData = "";
    if (this.e2eService.sRKeyVal && this.e2eService.sRKeyVal.length > 0) {
      encryptedData = this.e2eService.etd(data, 'pin');
    } else {
      this.e2eService.initE2e().pipe(catchError(this.errorHandler.bind(this))).subscribe(() => {
        if (this.e2eService.sRKeyVal && this.e2eService.sRKeyVal.length > 0) {
          encryptedData = this.e2eService.etd(data, 'pin');
        }
      });
    }
    return encryptedData;
  }



  clearFormOnError() {
    this._svcService.triggerProcessCompletionForSpinner(true);
    this.loginForm.reset();
    this.submitButtonDisabled = false;
    var inputTxt = this._el.nativeElement.querySelector('*[type^="text"]');
    var inputPwd = this._el.nativeElement.querySelector('*[type^="password"]');
    this.clearMaskedInput();
    this._renderer.removeClass(inputTxt, 'placeholderShown');
    this._renderer.removeClass(inputPwd, 'placeholderShown');
    console.log("this.siteIdCan5 === "+ this.siteIdCan);
    if(this.siteIdCan == "CACN_HOMEDEPOT") {
      var inputChkCookie = this._el.nativeElement.querySelector('*[id^="canadaCookieConsent"]');
      this._renderer.removeClass(inputChkCookie, 'placeholderShown');
    }

    this.error = (this.pageData.copy$$info_someting_went_wrong) ? this.pageData.copy$$info_someting_went_wrong.TEXT : '';
  }

  getSiteIdfromUrl() {
    let urlSearchVar = this._windowService.nativeWindow.location.search;
    var search = /([^&=]+)=?([^&]*)/g;
    if (urlSearchVar !== null || urlSearchVar !== "" || urlSearchVar !== undefined) {
      urlSearchVar = urlSearchVar.substring(1).toUpperCase();
      var searchArr = {};
      while (this.matchedId = search.exec(urlSearchVar)) {
        searchArr[(this.matchedId[1])] = (this.matchedId[2]);
      }
      console.log("the value from url" + searchArr);
      return searchArr["SITEID"];
    }
  }

  getBrandId(){
    if (this.pageData && this.pageData.config$$cfg_cw_app_client_settings.partner_enabled_for_brandId_for_qualtrics.includes(this._svcService.getSiteId())) {
    this.globalData = this._svcService.getGlobalData();
    const dataLayer = this.globalData.dataLayer;
    if(dataLayer.brandId == '' || dataLayer.brandId == null){
       dataLayer.brandId = this.pageData.copy$$default_brandId ? this.pageData.copy$$default_brandId.TEXT : "";
       this._windowService.nativeWindow.dataLayer.brandId = dataLayer.brandId;
    }
    }
}

  getSignNotifications() {
    try {
      let notification = this._svcService.getNotificationsFromSessionStorage();

      if (notification !== null && notification !== undefined) {
        console.log("Notification not null or undefined");

        this.notifications = JSON.parse(notification);
        this._svcService.removeNotificationsFromSessionStorage();
      }
    }
    catch (ex) {
      console.log('Exception in ngaSignOnSubmit' + ex);
    }
  }


  forgotUserId(e) {
    e.preventDefault();
    this.hashValue = '#retrieve';
    window.location.href = this.getRedirectUrl(this.hashValue);
  }

  resetPassword(e) {
    e.preventDefault();
    this.hashValue = '#reset';
    window.location.href = this.getRedirectUrl(this.hashValue);
  }

  registerYourCard(e) {
    this.scService.setSCPageData("customMinorInteraction", this.scPageData, {
      linkText: this.pageData?.cmlink$$link_get_started?.LINK_TEXT,
      area: "main", module: "get_started", view: "get_started", minorInteraction: "link_click"
    });
    let siteId = this.urlParameters.siteId;
    e.preventDefault();
    this.hashValue = '#verify';
    let uriSegment = '/RSnextgen/svc/registration/index.action?siteId=';
    if(this.pageData && this.pageData.config$$cfg_cw_app_client_settings.RSenroll_redirection_url_for_angular_registration_partners.includes(siteId?.toUpperCase())){
      uriSegment = '/RSenroll/registration?pageName=registration&siteId=';
    }
    window.location.href = this.getRedirectUrl(this.hashValue, uriSegment);
  }
  makeAPaymentGuestpay() {
    this.urlParameters = this._contentService.getParams();
    const langId = this.urlParameters.langId;
    this.guestUrl =
    '/RSauth/guestpay/guestpay?pageName=guestpay&siteId=' +
    this._svcService.pData.siteId;
    if (langId) {
    this.guestUrl = this.guestUrl + `&langId=${langId}`;
    }
   window.location.href = this.guestUrl;
  }

  redirectToFuip(e) {
      e.preventDefault();
      this.urlParameters = this._contentService.getParams();
      const langId = this.urlParameters.langId;
      this.fuipUrl =
      '/RSauth/fuip/fuip?pageName=fuip&siteId=' + this._svcService.pData.siteId;
      if (langId) {
      this.fuipUrl = this.fuipUrl + `&langId=${langId}`;
      }
     window.location.href = this.fuipUrl;
    }


  backToPasswordLogin(e) {
    e.preventDefault();
    this.error = "";
    this.isBiometricEligible = false;
    this.createLoginForm();
  }
  handleNotYou(e) {
    e.preventDefault();
    this.error = "";
    this.isBiometricEligible = false;
    this.createLoginForm();
  }

  proceedToBiometric(e) {
    e.preventDefault();
    this.biometricFormSubmitted = true;
    //console.log(this.biometricLoginForm.value);
    this.error = "";
    //console.log("Proceeding By Initializing TRASMIT API")
    // invoke authenticate journey call
    this.BiometricBTN = "PROCESSING..."
    // wait for authenticate journey call response
    //console.log("Sending Request to TRASMIT API")
    // SUCCESS :- redirect to legacy dashboard
    // this.biometricLoginForm.valid = true;
    this.crsFidoService.authenticationJourney().then((res) => {
      //console.log("Authenticate journey response : ", res);
      if (null == res || !(res instanceof String)) {
        this.error = this.pageData.copy$$errormsg_biometric_signon_fails ? this.pageData.copy$$errormsg_biometric_signon_fails.TEXT : "";
        this.biometricSubmitButtonDisabled = false;
        this.biometricButtonText = this.pageData.copy$$biometric_try_again_btn_sign_on ? this.pageData.copy$$biometric_try_again_btn_sign_on.TEXT : "";
        this.biometricButtonADAText = this.pageData.copy$$biometric_try_again_btn_sign_on ? this.pageData.copy$$biometric_try_again_btn_sign_on.WCAG_TEXT : "";
        this._svcService.triggerProcessCompletionForSpinner(true);
      }
      else {
        if (this.biometricLoginForm.valid) {
          this.biometricSubmitButtonDisabled = true;
          this.error = "";
          console.log("****Biometric Login From Validated Successfully **** Call Sign On Action Service From Here");
          let processName = '';
          let blackbox = encodeURIComponent(this._profiligServices.getCyotaData());
          let userCookie = 'testCoockie';
          let devicePrint = encodeURIComponent(this._profiligServices.getInetData());
          let DESC = this.route.snapshot.queryParams.desc;
          if (DESC == null || DESC == undefined) {
            DESC = '';
          }
          let cmp = this.route.snapshot.queryParams.cmp;
          if (cmp == null || cmp == undefined) {
            cmp = '';
          }
          let siteId = this.route.snapshot.queryParams.siteId;
          if (siteId == null || siteId == "" || siteId == undefined) {
            siteId = this.urlParameters.siteId;
          }
          if (siteId == null || siteId == "" || siteId == undefined) {
            siteId = this.getSiteIdfromUrl();
          }
          console.log("this.siteId biometric",siteId);
          if (siteId?.toUpperCase() == "PLCN_BESTBUY"){
              sessionStorage.setItem('bby_previous_page', "sign_on");
          }
          let langId = this.route.snapshot.queryParams.langId;
          let userFlow = 'ngaSignOn';
          let userId = this.biometricUserId;
          let userIdEncoded = encodeURIComponent(userId);
          let passwordEncoded = "";
          let isRememberEnabled = false;
          let snapshot_events = 'test_snapShot';
          let tmx_sessionId = this._profiligServices.get_new_tmx_sessionid();
          let windowId = this._contentService.getWindowIdFromSessionStorage();
          let biometricToken = res;

          let signOnRequest = 'processName=' + processName + '&'
            + 'blackbox=' + blackbox + '&'
            + 'userCookie=' + userCookie + '&'
            + 'devicePrint=' + devicePrint + '&'
            + 'DESC=' + DESC + '&'
            + 'cmp=' + cmp + '&'
            + 'siteId=' + siteId + '&'
            + 'langId=' + langId + '&'
            + 'userFlow=NGAsignon&'
            + 'userId=' + userIdEncoded + '&'
            + 'biometricToken=' + biometricToken + '&'
            + 'isBiometric=' + 'true' + '&'
            + 'cyotaUserId=' + this.biometricCyotaId + '&'
            + 'password=' + passwordEncoded + '&'
            + 'XXX_Extra=' + this.XXXExtra + '&'
            + 'snapshot_events=test&'
            + 'tmx_sessionId=' + tmx_sessionId + '&'
            + 'windowId=' + windowId;
          try {
            let headerData = {
              'Content-Type': 'application/x-www-form-urlencoded',
              'accept': 'text/json,application/json'
            };
            // Addede the below code to check biometric sign on submit
            //console.log("URL from sign-on-form-component.ts for invokeSignOn" + this.endpoints.get('ngaSignOn/submission'));
            return this._http.post(this.endpoints.get('ngaSignOn/submission'),
              signOnRequest, { headers: headerData }).subscribe((data) => {
                this.crsFidoService.transmitSessionLogout();
                if (data !== null && data !== undefined) {
                  let responseData = JSON.parse(JSON.stringify(data));
                  //console.log("if subcribe page data >>" + responseData.transId);

                  if (responseData.transId == "signonSuccess" || responseData.transId == "firsttime_user") {
                    this.chatbotService.chatBotDestroy();
                    //console.log("Re-directing to legacy");
                    this._contentService.createKnownUserKey();
                    if (isRememberEnabled) {
                      //this._storageService.set("userId", userId, StorageService.LOCALSTORAGE);
                      localStorage.setItem(siteId?.toUpperCase(), userId);
                    } else {
                      if(localStorage.getItem(this._svcService.getSiteId())) {
                        localStorage.removeItem(this._svcService.getSiteId());
                      }
                    }

                    window.location.href = this.getRedirectUrlForNgaSignon("&pagename=authenticate#ngaSignOn", "");
                  }
                  else if (responseData.transId == "redirectToResetPwd") {
                    //console.log("Re-directing to legacy redirectToResetPwd");
                    window.location.href = this.getRedirectUrl("#reset");
                  }
                  else if (responseData.transId == "redirectToRetrieveUserID") {
                    //console.log("Re-directing to legacy redirectToRetrieveUserID");
                    window.location.href = this.getRedirectUrl("#retrieve");
                  }
                  else {
                    //Display error message from sign on response
                    if (responseData.message !== null && responseData.message !== undefined) {
                      this.error = responseData.message;
                    }
                    if (responseData.notifications !== null && responseData.notifications !== undefined) {
                      this.notifications = responseData.notifications;
                    }
                    this.isBiometricEligible = false;
                    this.createLoginForm();
                    //this._storageService.delete("userId", StorageService.LOCALSTORAGE);
                    if(localStorage.getItem(this._svcService.getSiteId())) {
                      localStorage.removeItem(this._svcService.getSiteId());
                    }
                    this.loginForm.reset();
                    this.biometricSubmitButtonDisabled = false;
                    var inputTxt = this._el.nativeElement.querySelector('*[type^="text"]');
                    var inputPwd = this._el.nativeElement.querySelector('*[type^="password"]');
                    this.clearMaskedInput();
                    this._renderer.removeClass(inputTxt, 'placeholderShown');
                    this._renderer.removeClass(inputPwd, 'placeholderShown');
                    this._svcService.triggerProcessCompletionForSpinner(true);
                    console.log("data.transId >>> " + responseData.transId);
                  }
                } else {
                  this.crsFidoService.transmitSessionLogout();
                  this.clearFormOnError();
                }
              },
                (error: any): any => {
                  this.crsFidoService.transmitSessionLogout();
                  this.clearFormOnError();
                });

          }
          catch (ex) {
            this.crsFidoService.transmitSessionLogout();
            //console.log('Exception in ngaSignOnSubmit' + ex);
          }
        }
      }
    }).catch((err) => {
      //console.error("Error occured in authenticate journey call " + err);
      if (err && err.indexOf("timeout") == -1) {
        this.error = this.pageData.copy$$errormsg_biometric_signon_fails ? this.pageData.copy$$errormsg_biometric_signon_fails.TEXT : "";
        this.isBiometricEligible = false;
        this.createLoginForm();
        //this._storageService.delete("userId", StorageService.LOCALSTORAGE);
        if(localStorage.getItem(this._svcService.getSiteId())) {
          localStorage.removeItem(this._svcService.getSiteId());
        }
        this.loginForm.reset();
        this.biometricSubmitButtonDisabled = false;
        var inputTxt = this._el.nativeElement.querySelector('*[type^="text"]');
        var inputPwd = this._el.nativeElement.querySelector('*[type^="password"]');
        this.clearMaskedInput();
        this._renderer.removeClass(inputTxt, 'placeholderShown');
        this._renderer.removeClass(inputPwd, 'placeholderShown');
        this._svcService.triggerProcessCompletionForSpinner(true);
      } else {
        this.error = this.pageData.copy$$errormsg_biometric_signon_fails ? this.pageData.copy$$errormsg_biometric_signon_fails.TEXT : "";
        this.biometricSubmitButtonDisabled = false;
        this.biometricButtonText = this.pageData.copy$$biometric_try_again_btn_sign_on ? this.pageData.copy$$biometric_try_again_btn_sign_on.TEXT : "";
        this.biometricButtonADAText = this.pageData.copy$$biometric_try_again_btn_sign_on ? this.pageData.copy$$biometric_try_again_btn_sign_on.WCAG_TEXT : "";
        this._svcService.triggerProcessCompletionForSpinner(true);
      }
    });
  }

  getRedirectUrl(hashValue: any, uriSegment?: any) {
    this.urlParameters = this._contentService.getParams();
    let siteId = this.urlParameters.siteId;
    let langId = this.urlParameters.langId;
    let brandIdVal = this.urlParameters.brandId;
    let redirectURL = "";
    if (brandIdVal) {
      redirectURL = "/RSnextgen/svc/launch/index.action?siteId=" + siteId + "&brandId=" + brandIdVal;
    } else {
      redirectURL = "/RSnextgen/svc/launch/index.action?siteId=" + siteId;
    }
    if (uriSegment) {
      if (brandIdVal) {
        redirectURL = uriSegment + siteId + "&brandId=" + brandIdVal;
      } else {
        redirectURL = uriSegment + siteId;
      }
    }
    if (langId) {
      redirectURL = redirectURL + "&langId=" + langId;
    }
    if (hashValue) {
      redirectURL = redirectURL + hashValue;
    }
    return redirectURL;
  }

  getRedirectUrlForNgaSignon(hashValue: any, uriSegment?: any) {
    this.urlParameters = this._contentService.getParams();
    let siteId = this.urlParameters.siteId;
    let langId = this.urlParameters.langId;
    let redirectURL = "/RSnextgen/svc/launch/index.action?siteId=" + siteId;
    if (uriSegment) {
      redirectURL = uriSegment + siteId;
    }
    if (langId) {
      redirectURL = redirectURL + "&langId=" + langId;
    }
    if (hashValue) {
      redirectURL = redirectURL + hashValue;
    }
    return redirectURL;
  }

  private errorHandler(err): void {
    let message = 'The system is temporarily unavailable.';

  }
  @HostListener('click', ['$event']) onClick(e) {

    if (e.target.getAttribute("class") === 'signon_error_retrievelink') {
      console.log("forgotUserId");
      this.forgotUserId(e);
    }
    if (e.target.getAttribute("class") === 'signon_error_resetlink') {
      console.log("reset password");
      this.resetPassword(e);
    }
  }
  @HostListener('keyup', ['$event'])
  inputChanged(event) {
    if (event.target.value != "") {
      if (!event.target.classList.contains("placeholderShown")) {
        this._renderer.addClass(event.target, 'placeholderShown');
      }
    } else {
      this._renderer.removeClass(event.target, 'placeholderShown');
    }

    if (event.target.id == "userId") {
      //this._storageService.delete("userId", StorageService.LOCALSTORAGE);
      if(localStorage.getItem(this._svcService.getSiteId())) {
        localStorage.removeItem(this._svcService.getSiteId());
      }
      this.loginForm.controls.rememberMe.reset();
    }
  }

  clearMaskedInput() {
    var inputTxtMask = this._el.nativeElement.querySelector('.masked-input-view');
    if (inputTxtMask) {
      inputTxtMask.textContext = '';
      inputTxtMask.style.display = 'none';
    }
  }

  /*infoOutageWarningMessage() will Display warning messages in EST timezone using moment-timezone library
    Note: date and time should follow below format
    Date format: YYYY-MM-DD
    Time format: HH:mm
  */
  infoOutageWarningMessage() {
    let canShow = false;
    const EST_TZ = "America/New_York";
    let start: any;
    let end: any;
    this.urgentNotification = [];
    let now: any = moment.tz(EST_TZ);
    if (this.pageData && this.pageData.copy$$info_outage_message) {
      start = moment.tz(this.pageData.copy$$info_outage_message.Start_Date + ' ' + this.pageData.copy$$info_outage_message.Start_Time, EST_TZ);
      end = moment.tz(this.pageData.copy$$info_outage_message.End_Date + ' ' + this.pageData.copy$$info_outage_message.End_Time, EST_TZ);
      canShow = now.isSameOrAfter(start) && now.isSameOrBefore(end);
      if (canShow) {
        this.urgentNotification.push(this.pageData.copy$$info_outage_message.TEXT);
        if (this.notifications) {
          this.notifications = this.notifications.filter(
            item => item.alertMSG.toLowerCase() !== this.pageData.copy$$info_outage_message.TEXT.toLowerCase()
          );
        }
      }
    }
    if (this.pageData && this.pageData.copy$$info_partner_message) {
      start = moment.tz(this.pageData.copy$$info_partner_message.Start_Date + ' ' + this.pageData.copy$$info_partner_message.Start_Time, EST_TZ);
      end = moment.tz(this.pageData.copy$$info_partner_message.End_Date + ' ' + this.pageData.copy$$info_partner_message.End_Time, EST_TZ);
      canShow = now.isSameOrAfter(start) && now.isSameOrBefore(end);
      if (canShow) {
        this.urgentNotification.push(this.pageData.copy$$info_partner_message.TEXT);
        if (this.notifications) {
          this.notifications = this.notifications.filter(
            item => item.alertMSG.toLowerCase() !== this.pageData.copy$$info_partner_message.TEXT.toLowerCase()
          );
        }
      }
    }
    return (this.urgentNotification.length > 0);
  }

  async invokeAuthenticateJourney() {
    let biometricToken = null;
    biometricToken = await this.crsFidoService.authenticationJourney();
    return biometricToken;
  }

}
